<div class="modal-header">
  <h4 id="remove-recently-used-equipment-modal" class="modal-title">{{ "Remove from recently used" | translate }}</h4>
  <button
    (click)="modal.dismiss(RemoveRecentlyUsedEquipmentResult.CANCEL)"
    class="close"
    aria-describedby="modal-title"
    type="button"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <p class="alert alert-info">
    <strong>
      <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
      {{ "Are you sure you want to remove this item from your recently used list?" | translate }}
    </strong>
  </p>

  <p>
    {{
      "This will remove the item from your list of recently used equipment. If you add this equipment to an image again in the future, it will reappear in this list."
        | translate
    }}
  </p>

  <div *ngIf="!!item" class="card">
    <div class="card-header">
      {{ "Item" | translate }}
    </div>
    <div class="card-body">
      <astrobin-equipment-item-summary [item]="item" [showImage]="false" [showStats]="false">
      </astrobin-equipment-item-summary>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    (click)="modal.dismiss(RemoveRecentlyUsedEquipmentResult.CANCEL)"
    class="btn btn-outline-secondary"
    type="button"
  >
    {{ "Cancel" | translate }}
  </button>

  <button (click)="modal.close(RemoveRecentlyUsedEquipmentResult.CONFIRM)" class="btn btn-danger" type="button">
    {{ "Remove" | translate }}
  </button>
</div>
